import { HeroSection } from "./components/heroSection/heroSection";
import { About } from "./components/about/about";
import { HowItWorks } from "./components/howitworks/howitworks";
import { WhyAndy } from "./components/whyAndy/whyAndy";
import { TrustedByOwners } from "./components/trustByOwners/trustedByOwners";
import { PricingAndCredits } from "./components/pricing/pricingAndCredits";
import { ClientTestimonials } from "./components/testimonials/clientTestimonials";
import { FAQ } from "./components/faq/faq";
import { ContactAndDownload } from "./components/contactus/contactAndDownload";
// import { AndyCharacter } from "@/shared/components/common/AndyCharacter";
import { Footer } from "@/shared/layout/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Landing Page Component
 * Main landing page with hero section
 */
export const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.replace("#", "");
    if (!sectionId) return;

    if (sectionId === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash]);

  return (
    <>
      <HeroSection />
      <About />
      <HowItWorks />
      <WhyAndy />
      <TrustedByOwners />
      <PricingAndCredits />
      <ClientTestimonials />
      <FAQ />
      <ContactAndDownload />

      {/* Fixed Andy Character - visible throughout entire application */}
      {/* <AndyCharacter /> */}
      <Footer />
    </>
  );
};
